import { useEffect } from 'react';
import './download.scss';

function Download() {
  useEffect(() => {
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      const ele = document.getElementById('tips-download');
      if (ele?.style) {
        ele.style.display = 'block';
      }
    }
  }, []);

  return (
    <div className="download-content" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/image/policy-bg.png)` }}>
      <img
        className="logo"
        
        src={`${process.env.PUBLIC_URL}/image/logo.png`}
        alt="logo"
        style={{  width: 220,height: 220 }}
      />

      <div className="download-buttons">
        <button className="download-btn btn-android" onClick={() => {
          window.location.href = 'https://microdown.yyb.qq.com/o/simple.jsp?fromcase=70051&g_f=1182517&pkgname=com.taogao88.mowanquan&scenevia=XQYFX';
        }}>
          Android 下载
        </button>
        <button className="download-btn btn-harmony" onClick={() => {
          window.location.href = 'https://appgallery.huawei.com/app/detail?id=com.taogao88.mowanquan&channelId=SHARE&source=appshare';
        }}>
          鸿蒙下载
        </button>
        <button className="download-btn btn-ios" onClick={() => {
          window.location.href = 'https://apps.apple.com/cn/app/%E6%A1%83%E9%AB%98%E4%B9%90/id6762347484';
        }}>
          iOS 下载
        </button>
      </div>

      <div className="content-section">
        <p className="text-item">
          桃高乐是一个领先的潮流购物社区，我们为你打造 正品保障、极速物流、全品类覆盖 的一站式购物新体验。极速物流直邮到家！在这里，潮流不止步，惊喜无极限！
        </p>
        <p className="text-item">
          【潮玩手办，正版直供】 —— 从热门IP到稀缺限量，陪你解锁收藏的无限可能。
        </p>
        <p className="text-item">
          【电子产品、家电、箱包应有尽有】 —— 不只是买"想要的"，更能发现"意想不到的"。
        </p>
        <p className="text-item">
          【全网玩法，一网打尽】 —— 一发入魂的无限模式、热血比拼的擂台玩法、惊险刺激的爬塔挑战、期待满满的抽卡机、实惠爆棚的福利房，带来前所未有的潮流娱乐体验。
        </p>
        <p className="text-item">
          不仅如此，我们更懂你的坚持与热爱：
        </p>
        <p className="text-item highlight-text">
          【会员等级，福利加持】 —— 等级越高，特权越多，专属福利享不停。
        </p>
        <p className="text-item">
          【用户成长体系，回馈每一份热爱】 —— 让每一次点击与下单，都能积累属于你的荣耀。
        </p>
        <p className="text-item">
          买得到，玩得爽，收获快！
          在桃高乐，你不仅是购物者，更是探索者；你收获的不只是商品，更是潮流的惊喜与快乐！
        </p>
        <p className="text-item">
          桃高乐 —— 正品潮玩聚集地，惊喜盲盒随时开！
        </p>
      </div>

      <div id="tips-download">
        <img
          src={`${process.env.PUBLIC_URL}/image/wechat-tips.png`}
          alt=""
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
}

export default Download;
